import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { io } from 'socket.io-client';
import { Users, FileText, PenLine, Send, Gavel, Clock, Check, X, Minus, ChevronDown, ChevronUp, Paperclip, Scale, ChevronLeft } from 'lucide-react';
import { abrirDocumento } from './TodosProjetos';

// =====================================================================
// PLENARIUM:COMISSOES -- tela "Comissões" do vereador no tablet:
//  - Minhas relatorias: escrever o parecer, salvar rascunho, enviar
//    para a votacao da comissao e anexar o documento assinado
//  - Pareceres para votar: Acompanho o relator / Divirjo / Abstenção
//  - Presidente da comissao: designar relator e encerrar a votacao
// E o resumo dos pareceres (PareceresResumo) usado na votacao e na
// leitura do Secretario.
// =====================================================================

export const CONCLUSAO = { FAVORAVEL: 'Favorável', FAVORAVEL_EMENDAS: 'Favorável com emendas', CONTRARIO: 'Contrário', FAVORAVEL_RESSALVAS: 'Favorável com ressalvas' };
const COR_CONC = { FAVORAVEL: ['#15803d', '#dcfce7'], FAVORAVEL_EMENDAS: ['#15803d', '#dcfce7'], FAVORAVEL_RESSALVAS: ['#15803d', '#dcfce7'], CONTRARIO: ['#b91c1c', '#fee2e2'] };
const FUNCAO = { PRESIDENTE: 'Presidente', VICE_PRESIDENTE: 'Vice-Presidente', MEMBRO: 'Membro', SUPLENTE: 'Suplente' };
const TIPO_P = { PROJETO_LEI: 'Projeto de Lei', PROJETO_RESOLUCAO: 'Projeto de Resolução', PROJETO_DECRETO: 'Projeto de Decreto', REQUERIMENTO: 'Requerimento', MOCAO: 'Moção', INDICACAO: 'Indicação', OUTROS: 'Outros', ATA_ANTERIOR: 'Ata' };
const dataBR = (d) => (d ? new Date(d).toLocaleDateString('pt-BR') : '');

const CSS = `
.pcv { max-width: 980px; margin: 0 auto; padding: 4px 2px 40px; color: #0f172a; }
.pcv-cab { display: flex; align-items: center; gap: 14px; margin-bottom: 12px; }
.pcv-cab-ic { width: 52px; height: 52px; border-radius: 16px; background: #dcfce7; color: #15803d; display: flex; align-items: center; justify-content: center; flex: 0 0 auto; }
.pcv-cab b { display: block; font-size: 1.35rem; font-weight: 800; }
.pcv-cab small { display: block; color: #64748b; font-size: .9rem; margin-top: 2px; }
.pcv-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 16px; }
.pcv-chip { display: inline-flex; align-items: center; gap: 6px; padding: 5px 10px; border-radius: 999px; background: #fff; border: 1px solid #e2e8f0; font-size: .82rem; font-weight: 700; }
.pcv-chip small { color: #64748b; font-weight: 600; }
.pcv-sec { margin: 18px 0 10px; display: flex; align-items: center; gap: 8px; font-size: .78rem; font-weight: 800; letter-spacing: 1.4px; text-transform: uppercase; color: #475569; }
.pcv-sec span { background: #1d4ed8; color: #fff; border-radius: 999px; padding: 1px 8px; letter-spacing: 0; }
.pcv-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 14px; padding: 14px; margin-bottom: 10px; }
.pcv-card.alerta { border: 2px solid #dc2626; }
.pcv-tag { display: inline-block; font-size: .72rem; font-weight: 800; padding: 3px 9px; border-radius: 999px; margin: 0 6px 4px 0; }
.pcv-tit { font-weight: 700; font-size: 1.02rem; line-height: 1.3; margin: 4px 0; overflow-wrap: anywhere; }
.pcv-meta { color: #64748b; font-size: .85rem; display: flex; gap: 12px; flex-wrap: wrap; }
.pcv-bts { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
.pcv-bt { display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 46px; padding: 0 16px; border-radius: 12px; border: 1px solid #cbd5e1; background: #fff; color: #0f172a; font: inherit; font-weight: 700; font-size: .95rem; cursor: pointer; }
.pcv-bt[disabled] { opacity: .5; cursor: default; }
.pcv-bt.azul { background: #1d4ed8; border-color: #1d4ed8; color: #fff; }
.pcv-bt.verde { background: #15803d; border-color: #15803d; color: #fff; }
.pcv-bt.verm { background: #dc2626; border-color: #dc2626; color: #fff; }
.pcv-bt.amar { background: #f59e0b; border-color: #f59e0b; color: #fff; }
.pcv-bt.ativo { box-shadow: 0 0 0 3px #0f172a; }
.pcv-votos { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 12px; }
.pcv-votos .pcv-bt { min-height: 56px; }
.pcv-texto { white-space: pre-wrap; line-height: 1.55; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 10px 12px; margin-top: 10px; font-size: .95rem; max-height: 40vh; overflow-y: auto; }
.pcv-vazio { background: #fff; border: 1px dashed #cbd5e1; border-radius: 14px; padding: 18px; text-align: center; color: #64748b; }
.pcv-ed { position: fixed; inset: 0; z-index: 9000; background: #f8fafc; display: flex; flex-direction: column; }
.pcv-ed-topo { display: flex; align-items: center; gap: 10px; padding: calc(10px + env(safe-area-inset-top)) 14px 10px; background: #14532d; color: #fff; }
.pcv-ed-topo b { flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pcv-ed-corpo { flex: 1; min-height: 0; overflow-y: auto; padding: 16px clamp(14px, 4vw, 48px); }
.pcv-ed textarea { width: 100%; min-height: 42vh; box-sizing: border-box; border: 1px solid #cbd5e1; border-radius: 12px; padding: 12px; font: inherit; font-size: 1.05rem; line-height: 1.55; resize: vertical; background: #fff; color: #0f172a; }
.pcv-seg { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin: 10px 0 14px; }
.pcv-seg button { min-height: 50px; border-radius: 12px; border: 2px solid #e2e8f0; background: #fff; font: inherit; font-weight: 800; cursor: pointer; color: #334155; }
.pcv-seg button.ativo { border-color: #15803d; background: #dcfce7; color: #14532d; }
.pcv-seg button.ativo.contra { border-color: #b91c1c; background: #fee2e2; color: #7f1d1d; }
.pcv-ed-base { display: flex; flex-wrap: wrap; gap: 10px; padding: 12px 14px calc(12px + env(safe-area-inset-bottom)); border-top: 1px solid #e5e7eb; background: #fff; }
.pcv-ed-base .pcv-bt { flex: 1 1 180px; min-height: 54px; }
.pcv-sel { min-height: 44px; border-radius: 10px; border: 1px solid #cbd5e1; padding: 0 10px; font: inherit; background: #fff; color: #0f172a; }
/* resumo dos pareceres (votacao / leitura) */
.ppr { margin-top: 10px; }
.ppr-linha { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
.ppr-rot { font-size: .75rem; font-weight: 800; letter-spacing: 1px; color: #475569; text-transform: uppercase; margin-right: 2px; }
.ppr-chip { display: inline-flex; align-items: center; gap: 5px; border: 0; border-radius: 999px; padding: 5px 10px; font: inherit; font-size: .82rem; font-weight: 700; cursor: pointer; }
.ppr-det { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 10px 12px; margin-top: 8px; text-align: left; }
.ppr-det p { margin: 4px 0 0; white-space: pre-wrap; line-height: 1.5; }
@media (max-width: 640px) { .pcv-votos, .pcv-seg { grid-template-columns: 1fr; } }
`;

let sockCom = null;
function useTempoReal(camaraId, aoMudar) {
  useEffect(() => {
    if (!camaraId) return undefined;
    if (!sockCom) sockCom = io(process.env.REACT_APP_API_URL || 'http://localhost:3001');
    const s = sockCom;
    const entrar = () => { s.emit('entrar-sala', `camara-${camaraId}`); aoMudar(); };
    if (s.connected) s.emit('entrar-sala', `camara-${camaraId}`);
    s.on('connect', entrar); s.on('comissoes-atualizado', aoMudar);
    const voltou = () => { if (document.visibilityState === 'visible') aoMudar(); };
    document.addEventListener('visibilitychange', voltou);
    return () => { s.off('connect', entrar); s.off('comissoes-atualizado', aoMudar); document.removeEventListener('visibilitychange', voltou); };
  }, [camaraId, aoMudar]);
}

const nomeMat = (p) => (p ? (p.numero || TIPO_P[p.tipo] || 'Matéria') : 'Matéria');

function Docs({ projetoId, anexoId }) {
  const [docs, setDocs] = useState(null);
  const abrir = async () => {
    if (docs) { setDocs(null); return; }
    try {
      const r = await axios.get(`/api/projetos-camara/${projetoId}/documentos`);
      const l = [];
      if (r.data.temPrincipal) l.push({ k: 'p', t: 'Texto da matéria', url: `/api/projetos-camara/${projetoId}/principal` });
      (r.data.anexos || []).forEach(a => l.push({ k: a.id, t: a.nome, url: `/api/projetos-camara/anexo/${a.id}` }));
      setDocs(l);
    } catch { toast.error('Não foi possível buscar os documentos.'); }
  };
  return (
    <>
      <button type="button" className="pcv-bt" onClick={abrir}><FileText size={18} /> Documentos {docs ? <ChevronUp size={16} /> : <ChevronDown size={16} />}</button>
      {anexoId && <button type="button" className="pcv-bt" onClick={() => abrirDocumento(`/api/projetos-camara/anexo/${anexoId}`)}><Paperclip size={18} /> Parecer assinado</button>}
      {docs && <div style={{ flexBasis: '100%', display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {docs.length ? docs.map(d => <button key={d.k} type="button" className="pcv-bt" onClick={() => abrirDocumento(d.url)}><FileText size={16} /> {d.t}</button>) : <span style={{ color: '#64748b' }}>Nenhum documento anexado.</span>}
      </div>}
    </>
  );
}

export default function ComissoesVereador({ usuario }) {
  const [dados, setDados] = useState(null);
  const [editor, setEditor] = useState(null); // { r, texto, conclusao }
  const [aberto, setAberto] = useState({});
  const [ocupado, setOcupado] = useState(false);
  const camaraId = usuario && usuario.camaraId;

  const carregar = useCallback(() => {
    axios.get('/api/comissoes/minhas').then(r => setDados(r.data)).catch(() => setDados(d => d || { erro: true }));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  useTempoReal(camaraId, carregar);

  const acao = async (fn, ok) => {
    setOcupado(true);
    try { const r = await fn(); if (ok) toast.success(ok); carregar(); return r || true; }
    catch (err) { toast.error(err.response?.data?.error || 'Não foi possível concluir.'); return false; }
    finally { setOcupado(false); }
  };
  const anexar = (r) => (e) => {
    const f = e.target.files[0]; if (!f) return;
    if (f.size > 5 * 1024 * 1024) { toast.error('O limite é 5MB.'); e.target.value = ''; return; }
    const rd = new FileReader(); rd.onload = () => acao(() => axios.post(`/api/comissoes/relatoria/${r.id}/anexo`, { nome: `Parecer ${r.comissao.sigla || r.comissao.nome}`, arquivo: rd.result }), 'Parecer assinado anexado!'); rd.readAsDataURL(f);
  };

  if (!dados) return <div className="pcv"><style>{CSS}</style><div className="pcv-vazio">Carregando…</div></div>;
  if (dados.erro) return <div className="pcv"><style>{CSS}</style><div className="pcv-vazio">Não foi possível carregar as comissões. Toque em Atualizar.</div></div>;

  const { comissoes = [], relatorias = [], paraVotar = [], presidir = [], concluidas = [], documentos = [], documentosNovos = 0 } = dados; // PLENARIUM:PROTOCOLO_COMISSOES
  const presidirPend = presidir.filter(r => r.status === 'AGUARDANDO_RELATOR' || r.status === 'EM_VOTACAO');

  return (
    <div className="pcv"><style>{CSS}</style>
      <div className="pcv-cab">
        <span className="pcv-cab-ic"><Users size={28} /></span>
        <span><b>Comissões</b><small>Relatorias, pareceres e votações das comissões</small></span>
      </div>
      {comissoes.length > 0 && (
        <div className="pcv-chips">{comissoes.map(c => <span key={c.id} className="pcv-chip">{c.sigla || c.nome}<small>· {FUNCAO[c.funcao] || ''}</small></span>)}</div>
      )}

      {/* ---- Documentos recebidos pelo protocolo (PLENARIUM:PROTOCOLO_COMISSOES) ---- */}
      {documentos.length > 0 && <>
        <div className="pcv-sec">Documentos recebidos {documentosNovos > 0 && <span>{documentosNovos}</span>}</div>
        {documentos.map(d => (
          <div key={d.id} className="pcv-card" style={d.lido ? undefined : { border: '2px solid #1d4ed8' }}>
            <span className="pcv-tag" style={{ color: '#3730a3', background: '#e0e7ff' }}>{d.comissao}</span>
            {!d.lido && <span className="pcv-tag" style={{ color: '#fff', background: '#1d4ed8' }}>NOVO</span>}
            <div className="pcv-tit">Protocolo nº {d.numero} — {d.assunto}</div>
            <div className="pcv-meta"><span>De: {d.remetente}</span><span>Recebido em {dataBR(d.enviadoEm)}</span>{d.enviadoPor && <span>Enviado por {d.enviadoPor}</span>}</div>
            {(d.observacao || d.descricao) && <div className="pcv-texto" style={{ maxHeight: '24vh' }}>{d.observacao ? `${d.observacao}\n\n` : ''}{d.descricao || ''}</div>}
            <div className="pcv-bts">
              {d.temAnexo && <button type="button" className="pcv-bt azul" onClick={async () => { await abrirDocumento(`/api/protocolos/comissao/${d.id}/documento`); carregar(); }}><FileText size={18} /> Ver documento</button>}
              {!d.lido && <button type="button" className="pcv-bt" disabled={ocupado} onClick={() => acao(() => axios.post(`/api/protocolos/comissao/${d.id}/lido`), null)}><Check size={18} /> Marcar como lido</button>}
            </div>
          </div>
        ))}
      </>}

      {/* ---- Minhas relatorias ---- */}
      <div className="pcv-sec">Minhas relatorias {relatorias.length > 0 && <span>{relatorias.length}</span>}</div>
      {!relatorias.length ? <div className="pcv-vazio">Nenhuma matéria aguardando o seu parecer.</div> : relatorias.map(r => (
        <div key={r.id} className={`pcv-card ${r.prazoVencido ? 'alerta' : ''}`}>
          <span className="pcv-tag" style={{ color: '#3730a3', background: '#e0e7ff' }}>{r.comissao.sigla || r.comissao.nome}</span>
          <span className="pcv-tag" style={r.parecerTexto ? { color: '#92400e', background: '#fef3c7' } : { color: '#475569', background: '#f1f5f9' }}>{r.parecerTexto ? 'RASCUNHO SALVO' : 'PARECER A FAZER'}</span>
          <div className="pcv-tit">{nomeMat(r.projeto)} — {r.projeto && r.projeto.ementa}</div>
          <div className="pcv-meta">
            {r.projeto && r.projeto.autor && <span>Autoria: {r.projeto.autor}</span>}
            {r.prazo && <span style={{ color: r.prazoVencido ? '#b91c1c' : undefined, fontWeight: r.prazoVencido ? 800 : 400 }}><Clock size={13} style={{ verticalAlign: '-2px' }} /> Prazo: {dataBR(r.prazo)}{r.prazoVencido ? ' · VENCIDO' : ''}</span>}
          </div>
          <div className="pcv-bts">
            <button type="button" className="pcv-bt azul" onClick={() => setEditor({ r, texto: r.parecerTexto || '', conclusao: r.parecerConclusao || '' })}><PenLine size={18} /> {r.parecerTexto ? 'Continuar parecer' : 'Escrever parecer'}</button>
            <Docs projetoId={r.projetoId} anexoId={r.anexoId} />
          </div>
        </div>
      ))}

      {/* ---- Para votar ---- */}
      <div className="pcv-sec">Pareceres para votar {paraVotar.filter(r => !r.meuVoto).length > 0 && <span>{paraVotar.filter(r => !r.meuVoto).length}</span>}</div>
      {!paraVotar.length ? <div className="pcv-vazio">Nenhum parecer em votação nas suas comissões.</div> : paraVotar.map(r => {
        const [cor, fundo] = COR_CONC[r.parecerConclusao] || ['#475569', '#f1f5f9'];
        const ab = !!aberto[r.id];
        return (
          <div key={r.id} className="pcv-card">
            <span className="pcv-tag" style={{ color: '#3730a3', background: '#e0e7ff' }}>{r.comissao.sigla || r.comissao.nome}</span>
            <span className="pcv-tag" style={{ color: cor, background: fundo }}>RELATOR: {(CONCLUSAO[r.parecerConclusao] || '').toUpperCase()}</span>
            {r.meuVoto && <span className="pcv-tag" style={{ color: '#fff', background: '#0f172a' }}>SEU VOTO: {r.meuVoto === 'ACOMPANHA' ? 'ACOMPANHA' : r.meuVoto === 'DIVERGE' ? 'DIVERGE' : 'ABSTENÇÃO'}</span>}
            <div className="pcv-tit">{nomeMat(r.projeto)} — {r.projeto && r.projeto.ementa}</div>
            <div className="pcv-meta"><span>Relator(a): <b>{r.relator ? r.relator.nome : '—'}</b></span><span>Votos: {r.contagem.ACOMPANHA + r.contagem.DIVERGE + r.contagem.ABSTENCAO} de {r.totalTitulares}</span></div>
            <button type="button" className="pcv-bt" style={{ marginTop: 10 }} onClick={() => setAberto(a => ({ ...a, [r.id]: !ab }))}>{ab ? <ChevronUp size={16} /> : <ChevronDown size={16} />} {ab ? 'Fechar o parecer' : 'Ler o parecer'}</button>
            {ab && <div className="pcv-texto">{r.parecerTexto}</div>}
            {r.souRelator ? <div className="pcv-meta" style={{ marginTop: 10 }}>Você é o relator: seu voto acompanha o parecer.</div> : (
              <div className="pcv-votos">
                <button type="button" disabled={ocupado} className={`pcv-bt verde ${r.meuVoto === 'ACOMPANHA' ? 'ativo' : ''}`} onClick={() => acao(() => axios.post(`/api/comissoes/relatoria/${r.id}/votar`, { voto: 'ACOMPANHA' }), 'Voto registrado!')}><Check size={20} /> Acompanho o relator</button>
                <button type="button" disabled={ocupado} className={`pcv-bt verm ${r.meuVoto === 'DIVERGE' ? 'ativo' : ''}`} onClick={() => acao(() => axios.post(`/api/comissoes/relatoria/${r.id}/votar`, { voto: 'DIVERGE' }), 'Voto registrado!')}><X size={20} /> Divirjo</button>
                <button type="button" disabled={ocupado} className={`pcv-bt amar ${r.meuVoto === 'ABSTENCAO' ? 'ativo' : ''}`} onClick={() => acao(() => axios.post(`/api/comissoes/relatoria/${r.id}/votar`, { voto: 'ABSTENCAO' }), 'Voto registrado!')}><Minus size={20} /> Abstenção</button>
              </div>
            )}
          </div>
        );
      })}

      {/* ---- Presidente da comissao ---- */}
      {presidir.length > 0 && <>
        <div className="pcv-sec">Presidência da comissão {presidirPend.length > 0 && <span>{presidirPend.length}</span>}</div>
        {presidir.map(r => (
          <div key={r.id} className="pcv-card">
            <span className="pcv-tag" style={{ color: '#3730a3', background: '#e0e7ff' }}>{r.comissao.sigla || r.comissao.nome}</span>
            <span className="pcv-tag" style={{ color: '#475569', background: '#f1f5f9' }}>{r.status === 'AGUARDANDO_RELATOR' ? 'SEM RELATOR' : r.status === 'EM_VOTACAO' ? 'EM VOTAÇÃO' : 'COM O RELATOR'}</span>
            <div className="pcv-tit">{nomeMat(r.projeto)} — {r.projeto && r.projeto.ementa}</div>
            {r.status !== 'EM_VOTACAO' ? (
              <div className="pcv-bts" style={{ alignItems: 'center' }}>
                <span style={{ fontWeight: 700 }}>Relator(a):</span>
                <select className="pcv-sel" value={r.relator ? r.relator.id : ''} disabled={ocupado} onChange={e => acao(() => axios.patch(`/api/comissoes/relatoria/${r.id}`, { relatorId: e.target.value || null }), 'Relator designado!')}>
                  <option value="">— escolher —</option>
                  {r.membros.map(m => <option key={m.vereadorId} value={m.vereadorId}>{m.nome}</option>)}
                </select>
                <span style={{ fontWeight: 700 }}>Prazo:</span>
                <input type="date" className="pcv-sel" value={r.prazo ? String(r.prazo).slice(0, 10) : ''} disabled={ocupado} onChange={e => acao(() => axios.patch(`/api/comissoes/relatoria/${r.id}`, { prazo: e.target.value || null }), 'Prazo salvo!')} />
              </div>
            ) : (
              <>
                <div className="pcv-meta" style={{ marginTop: 6 }}>
                  <span>Acompanham: <b>{r.contagem.ACOMPANHA}</b></span><span>Divergem: <b>{r.contagem.DIVERGE}</b></span><span>Abstenções: <b>{r.contagem.ABSTENCAO}</b></span><span>Faltam: <b>{Math.max(0, r.totalTitulares - r.contagem.ACOMPANHA - r.contagem.DIVERGE - r.contagem.ABSTENCAO)}</b></span>
                </div>
                <div className="pcv-bts">
                  <button type="button" className="pcv-bt azul" disabled={ocupado} onClick={() => { if (window.confirm(`Encerrar a votação do parecer?\n\nAcompanham: ${r.contagem.ACOMPANHA} · Divergem: ${r.contagem.DIVERGE} · Abstenções: ${r.contagem.ABSTENCAO}`)) acao(() => axios.post(`/api/comissoes/relatoria/${r.id}/encerrar`), 'Votação encerrada!'); }}><Gavel size={18} /> Encerrar votação</button>
                </div>
              </>
            )}
          </div>
        ))}
      </>}

      {/* ---- Concluidos ---- */}
      {concluidas.length > 0 && <>
        <div className="pcv-sec">Concluídos recentemente</div>
        {concluidas.map(r => (
          <div key={r.id} className="pcv-card" style={{ padding: '10px 14px' }}>
            <span className="pcv-tag" style={{ color: '#3730a3', background: '#e0e7ff' }}>{r.comissao.sigla || r.comissao.nome}</span>
            <span className="pcv-tag" style={r.resultado === 'APROVADO' ? { color: '#15803d', background: '#dcfce7' } : { color: '#b91c1c', background: '#fee2e2' }}>PARECER {r.resultado === 'APROVADO' ? 'APROVADO' : 'REJEITADO'}{r.placar ? ` · ${r.placar}` : ''}</span>
            <div className="pcv-tit" style={{ fontSize: '.95rem' }}>{nomeMat(r.projeto)} — {r.projeto && r.projeto.ementa}</div>
          </div>
        ))}
      </>}

      {/* ---- Editor do parecer ---- */}
      {editor && (
        <div className="pcv-ed" role="dialog" aria-label="Parecer do relator">
          <div className="pcv-ed-topo">
            <button type="button" className="pcv-bt" style={{ minHeight: 40, background: 'rgba(255,255,255,.14)', borderColor: 'rgba(255,255,255,.3)', color: '#fff' }} onClick={() => setEditor(null)}><ChevronLeft size={18} /> Voltar</button>
            <b>Parecer — {editor.r.comissao.sigla || editor.r.comissao.nome} · {nomeMat(editor.r.projeto)}</b>
          </div>
          <div className="pcv-ed-corpo">
            <div className="pcv-tit">{editor.r.projeto && editor.r.projeto.ementa}</div>
            <div style={{ fontWeight: 800, marginTop: 14 }}>Conclusão do seu parecer</div>
            <div className="pcv-seg">
              {['FAVORAVEL', 'FAVORAVEL_EMENDAS', 'CONTRARIO'].map(c => (
                <button key={c} type="button" className={`${editor.conclusao === c ? 'ativo' : ''} ${c === 'CONTRARIO' ? 'contra' : ''}`} onClick={() => setEditor({ ...editor, conclusao: c })}>{CONCLUSAO[c]}</button>
              ))}
            </div>
            <div style={{ fontWeight: 800, marginBottom: 6 }}>Texto do parecer</div>
            <textarea value={editor.texto} onChange={e => setEditor({ ...editor, texto: e.target.value })} placeholder={'I – RELATÓRIO\n\nII – VOTO DO RELATOR\n\nIII – CONCLUSÃO'} />
            <div className="pcv-bts">
              <Docs projetoId={editor.r.projetoId} anexoId={editor.r.anexoId} />
              <label className="pcv-bt" style={{ cursor: 'pointer' }}><Paperclip size={18} /> Anexar parecer assinado (PDF)<input type="file" accept=".pdf,image/*" style={{ display: 'none' }} onChange={anexar(editor.r)} /></label>
            </div>
          </div>
          <div className="pcv-ed-base">
            <button type="button" className="pcv-bt" disabled={ocupado} onClick={async () => { if (await acao(() => axios.put(`/api/comissoes/relatoria/${editor.r.id}/parecer`, { texto: editor.texto, conclusao: editor.conclusao || null }), 'Rascunho salvo!')) setEditor(null); }}>Salvar rascunho</button>
            <button type="button" className="pcv-bt verde" disabled={ocupado || !editor.texto.trim() || !editor.conclusao} onClick={async () => {
              if (!window.confirm('Enviar o parecer para a votação da comissão?\n\nDepois de enviado, ele não pode mais ser alterado.')) return;
              if (await acao(() => axios.post(`/api/comissoes/relatoria/${editor.r.id}/enviar`, { texto: editor.texto, conclusao: editor.conclusao }), 'Parecer enviado para a votação da comissão!')) setEditor(null);
            }}><Send size={18} /> Enviar para votação</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ---------------------------------------------------------------------
// Resumo dos pareceres de uma materia (tela de votacao e leitura).
// Nao mostra nada se a materia nao tiver parecer concluido.
// ---------------------------------------------------------------------
export function PareceresResumo({ projetoId, grande = false }) {
  const [d, setD] = useState(null);
  const [aberto, setAberto] = useState(null);
  useEffect(() => {
    if (!projetoId) { setD(null); return undefined; }
    let vivo = true;
    axios.get(`/api/comissoes/projeto/${projetoId}`).then(r => { if (vivo) setD(r.data); }).catch(() => { if (vivo) setD(null); });
    return () => { vivo = false; };
  }, [projetoId]);
  if (!d) return null;
  const rels = (d.relatorias || []).filter(r => r.status === 'CONCLUIDO');
  const jur = d.juridicos || [];
  if (!rels.length && !jur.length) return null;
  const itens = [
    ...rels.map(r => ({ k: r.id, rot: r.comissao.sigla || r.comissao.nome, nome: r.comissao.nome, conc: r.parecerConclusao, res: r.resultado, placar: r.placar, quem: r.relator ? `Relator(a): ${r.relator.nome}` : '', texto: r.parecerTexto, anexoId: r.anexoId })),
    ...jur.map(j => ({ k: j.id, rot: 'Jurídico', nome: j.orgao || 'Procuradoria Jurídica', conc: j.conclusao, quem: `${j.parecerista}${j.oab ? `, OAB ${j.oab}` : ''}`, texto: j.resumo, anexoId: j.anexoId, juridico: true }))
  ];
  const sel = itens.find(i => i.k === aberto);
  return (
    <div className="ppr" style={grande ? { fontSize: 18 } : undefined}>
      <style>{CSS}</style>
      <div className="ppr-linha">
        <span className="ppr-rot"><Scale size={12} style={{ verticalAlign: '-1px' }} /> Pareceres:</span>
        {itens.map(i => {
          const contra = i.conc === 'CONTRARIO' || i.res === 'REJEITADO';
          return (
            <button key={i.k} type="button" className="ppr-chip" style={contra ? { color: '#991b1b', background: '#fee2e2' } : { color: '#166534', background: '#dcfce7' }} onClick={() => setAberto(aberto === i.k ? null : i.k)}>
              {i.rot}: {CONCLUSAO[i.conc] || '—'}{!i.juridico && i.res === 'REJEITADO' ? ' (rejeitado)' : ''} {aberto === i.k ? <ChevronUp size={13} /> : <ChevronDown size={13} />}
            </button>
          );
        })}
      </div>
      {sel && (
        <div className="ppr-det">
          <b>{sel.juridico ? 'Parecer jurídico' : 'Parecer'} — {sel.nome}</b>
          <div style={{ color: '#64748b', fontSize: '.88em' }}>{CONCLUSAO[sel.conc]}{!sel.juridico && sel.res ? ` · parecer ${sel.res === 'APROVADO' ? 'aprovado' : 'rejeitado'} pela comissão${sel.placar ? ` (${sel.placar})` : ''}` : ''}{sel.quem ? ` · ${sel.quem}` : ''}</div>
          {sel.texto && <p>{sel.texto}</p>}
          {sel.anexoId && <button type="button" className="pcv-bt" style={{ marginTop: 8 }} onClick={() => abrirDocumento(`/api/projetos-camara/anexo/${sel.anexoId}`)}><FileText size={16} /> Abrir documento assinado</button>}
        </div>
      )}
    </div>
  );
}
